import { Paper, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { useDispatch } from "react-redux";
import { getToken, requestErrorHandler } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";

const server = EnvSettings.server;

const getFields = (data, key) => {
  if (!key || !data) {
    return;
  }
  var arr;
  if (key.includes(".")) {
    arr = key.split(".");
  }
  if (!arr) {
    arr = [key];
  }
  var value;
  arr.forEach((element, i) => {
    if (i === 0) {
      value = Object.keys(data).find((a) => a === element) ? data[element] : "";
    } else {
      value = Object.keys(value).find((a) => a === element)
        ? value[element]
        : "";
    }
    if (value && Array.isArray(value) && value.length) {
      value = value.sort((a, b) => b.id - a.id)[0];
    }
  });
  if (key.includes("quality") && value) {
    return "Class: " + value;
  }
  return value || "";
};

export default function ShipmentSearchAutocomplete({
  onChange,
  userGroup,
  required,
  defaultValue,
  label,
  email,
  style,
  additionalDataFields,
  additionalFilters,
}) {
  const dispatch = useDispatch();
  const [usersList, setUsersList] = useState([]);
  const [loadingUsersList, setLoadingUsersList] = useState(false);
  const { t } = useTranslation();
  const abortcontroller = useRef();

  const getUsers = (ser_val) => {
    if (!ser_val) {
      return;
    }
    if (abortcontroller.current) {
      abortcontroller.current.abort();
    }

    // Create a new abortcontroller for the new request
    abortcontroller.current = new AbortController();
    setLoadingUsersList(true);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        // search_value: ser_val,
      }),
      signal: abortcontroller.current.signal,
    };
    fetch(server + "/get_device_profiles", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setUsersList(result.deviceprofiles);
        }
        setLoadingUsersList(false);
      })
      .catch((error) => {
        if (error?.name === "AbortError") {
          return;
        }
        console.log(error);
      });
  };
  return (
    <Grid item xs={12} style={style || {}}>
      <Autocomplete
        id="device_profiles"
        options={[...(usersList ? usersList : [])]}
        fullWidth
        getOptionSelected={(option, value) => {
          return option.id === value.id;
        }}
        PaperComponent={(props) => (
          <Paper style={{ border: "2px solid #3d57a5" }} {...props} />
        )}
        getOptionLabel={(option) => {
          if (!option || !option.id) {
            return "";
          }
          return option.name;
        }}
        loading={loadingUsersList}
        defaultValue={{ name: defaultValue }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label || t("emailList.deviceProfile")}
            variant="outlined"
            required={required}
          />
        )}
        renderOption={(option, { selected }) => (
          <React.Fragment key={option.name}>
            <Grid container>
              <Grid item xs={12}>
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  {option.name}
                </Typography>
              </Grid>
              {additionalDataFields
                ? additionalDataFields.map((m, i) => (
                    <Grid key={i} item xs={12}>
                      <Typography style={{ fontSize: 12 }}>
                        {getFields(option, m)}
                      </Typography>
                    </Grid>
                  ))
                : null}
            </Grid>
          </React.Fragment>
        )}
        onChange={onChange}
        onChangeCapture={(e) => {
          var v;
          if (e.target.value) {
            v = e.target.value.toLowerCase();
          }
          getUsers(v);
          // getClientInfo(v);
        }}
      />
    </Grid>
  );
}
